module.exports = __webpack_public_path__ + "img/videoimg1.e0a50db2.jpg";